export class RegistrationFinalizationResponseModel {
	success: boolean;
	reasons: Record<number, string>;
}

export class RegistrationRecoverGradesResponseModel {
	success: boolean;
	message: string;
}
